import AddressParse from 'address-parse';

export const formatAddress = addressStr => {
  const [result] = AddressParse.parse(addressStr);
  return result;
};



// WEBPACK FOOTER //
// ./src/utils/formatAddress.js